import {mapState} from 'vuex';

export const mobileAppAutofocusMixin = {
	props: {
		autofocus: {
			type:    Boolean,
			default: false,
		},
	},

	computed: {
		...mapState(['isWebApp']),

		$autofocus() {
			return this.isWebApp && this.$props.autofocus;
		},
	},
}
